import "./CustomizationInfoV2.less";
import React from "react";
import { Tooltip } from "antd";
import { PhoneCaseCustomizationInfo } from "@/dto/order/CustomizationInfoDTO";
import ProxyImage from "@/components/ProxyImage";
import { observer } from "mobx-react-lite";

function convertAliCdnImageQuantity(url?: string, reWidth = 400, quantity = 75) {
    if (!url) {
        return url;
    }

    try {
        const urlParsed = URL.parse(url);

        if (urlParsed.host === "isv.alibabausercontent.com" || urlParsed.host === "img.alicdn.com") {
            return `${url}_${reWidth}x${reWidth}q${quantity}`;
        }

        if (urlParsed.host?.endsWith(".aliyuncs.com") || urlParsed.host?.endsWith(".laihuo.cn")) {
            return `${url}?x-oss-process=image/resize,w_${reWidth},h_${reWidth}/quality,q_${quantity}`;
        }
    } catch (error) {}

    return url;
}

interface CustomizationInfoV2Props {
    info: PhoneCaseCustomizationInfo;
}

const CustomizationInfoV2: React.FC<CustomizationInfoV2Props> = function (props) {
    const { info } = props;

    const smallPic = convertAliCdnImageQuantity(info.customizedImageUrl);
    const smallEffectPic = convertAliCdnImageQuantity(info.previewImageUrl);

    const originalPicEl = <ProxyImage src={info.customizedImageUrl} alt="" style={{ width: "100%" }} />;
    const originalEffectPicEl = <ProxyImage src={info.previewImageUrl} alt="" style={{ width: "100%" }} />;

    const content = [
        info.phoneBrandName,
        info.phoneModelName,
        info.phoneCaseMaterialName,
        info.phoneCaseMaterialColorName,
    ]
        .filter((it) => !!it)
        .join("-");

    return (
        <div className="ec-phone-customization-info-v2-item-container">
            {smallPic ? (
                <Tooltip destroyOnHidden title={originalPicEl}>
                    <span className="customization-image">
                        <ProxyImage src={smallPic} alt="" />{" "}
                    </span>
                </Tooltip>
            ) : null}

            {smallEffectPic ? (
                <Tooltip destroyOnHidden title={originalEffectPicEl}>
                    <span className="customization-image">
                        <ProxyImage src={smallEffectPic} alt="" />
                    </span>
                </Tooltip>
            ) : null}

            <span className="content">{content}</span>
        </div>
    );
};

export default observer(CustomizationInfoV2);
